// extracted by mini-css-extract-plugin
module.exports = {"slide":"c9uNnvv","gallery":"lBCr9G"};